<div class="success-modal-body">
    <i class="icon icon-add pull-right close-icon-x icon-times" 
       ng-click="$close()" style="font-size: 40px;"></i>
    <span ng-hide="vm.hideIcon"  class="addiko-icon addiko-icon-success"></span>
    <span ng-class="{'pt-10 pb-10': vm.hideIcon}" class="success-message" 
          ng-bind-html="(vm.message | translate)"></span>
</div>